interface CharaExpression {
    src: string
    width: number
    height: number
    offsetX?: number
}

interface CharaConfig {
    expressions: Record<string, CharaExpression>
    label?: string
}

export const charaAssetsMap: Record<string, CharaConfig> = {
    "map.speaker.passenger": {
        expressions: {
            calm: {
                src: require("@/assets/imgs/dialog/chara/passenger-calm.png"),
                width: 199,
                height: 245,
            },
            eyeclosed: {
                src: require("@/assets/imgs/dialog/chara/passenger-eyeclosed.png"),
                width: 199,
                height: 245,
            },
        },
    },
    "map.speaker.amiya": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/amiya-smile.png"),
                width: 197,
                height: 258,
                offsetX: 4,
            },
            confused: {
                src: require("@/assets/imgs/dialog/chara/amiya-confused.png"),
                width: 228,
                height: 258,
                offsetX: 34.5,
            },
            rconfused: {
                src: require("@/assets/imgs/dialog/chara/amiya-rconfused.png"),
                width: 215,
                height: 258,
                offsetX: 4,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/amiya-happy.png"),
                width: 197,
                height: 258,
                offsetX: 4,
            },
            thinking: {
                src: require("@/assets/imgs/dialog/chara/amiya-thinking.png"),
                width: 208,
                height: 260,
                offsetX: 12,
            },
        },
    },
    "map.speaker.pepe": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/pepe-normal.png"),
                width: 197,
                height: 215,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/pepe-happy.png"),
                width: 197,
                height: 215,
            },
        },
    },
    "map.speaker.savage": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/savage-smile.png"),
                width: 218,
                height: 261,
                offsetX: 8,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/savage-happy.png"),
                width: 218,
                height: 261,
                offsetX: 8,
            },
            thinking: {
                src: require("@/assets/imgs/dialog/chara/savage-thinking.png"),
                width: 222,
                height: 263,
                offsetX: 10,
            },
        },
    },
    "map.speaker.brigid": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/brigid-smile.png"),
                width: 215,
                height: 211,
            },
            confused: {
                src: require("@/assets/imgs/dialog/chara/brigid-confused.png"),
                width: 243,
                height: 211,
                offsetX: 0,
            },
        },
    },
    "map.speaker.lessing": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/lessing-normal.png"),
                width: 319,
                height: 223,
                offsetX: 48,
            },
        },
    },
    "map.speaker.magallan": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/magallan-smile.png"),
                width: 196,
                height: 172,
            },
        },
    },
    "map.speaker.santalla": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/santalla-normal.png"),
                width: 224,
                height: 261,
                offsetX: 16,
            },
        },
    },
    "map.speaker.doctor": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/doctor-normal.png"),
                width: 178,
                height: 207,
                offsetX: -15,
            },
            confused: {
                src: require("@/assets/imgs/dialog/chara/doctor-confused.png"),
                width: 231,
                height: 207,
                offsetX: 24,
            },
            rconfused: {
                src: require("@/assets/imgs/dialog/chara/doctor-rconfused.png"),
                width: 216,
                height: 207,
                offsetX: -15,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/doctor-happy.png"),
                width: 294,
                height: 211,
                offsetX: 22,
            },
            thinking: {
                src: require("@/assets/imgs/dialog/chara/doctor-thinking.png"),
                width: 178,
                height: 207,
                offsetX: -15,
            },
        },
    },
    "map.speaker.closure": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/closure-normal.png"),
                width: 210,
                height: 205,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/closure-happy.png"),
                width: 210,
                height: 205,
            },
        },
    },
    "map.speaker.ebenholz": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/ebenholz-normal.png"),
                width: 224,
                height: 245,
                offsetX: 20,
            },
            eyeclosed: {
                src: require("@/assets/imgs/dialog/chara/ebenholz-eyeclosed.png"),
                width: 224,
                height: 245,
                offsetX: 20,
            },
        },
    },
    "map.speaker.heidi": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/heidi-smile.png"),
                width: 299,
                height: 229,
                offsetX: 38,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/heidi-happy.png"),
                width: 299,
                height: 229,
                offsetX: 38,
            },
        },
    },
    "map.speaker.mon3tr": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/mon3tr-smile.png"),
                width: 221,
                height: 224,
                offsetX: 12,
            },
            confused: {
                src: require("@/assets/imgs/dialog/chara/mon3tr-confused.png"),
                width: 221,
                height: 224,
                offsetX: 12,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/mon3tr-happy.png"),
                width: 221,
                height: 224,
                offsetX: 12,
            },
        },
    },
    "map.speaker.odda": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/odda-smile.png"),
                width: 213,
                height: 209,
                offsetX: 16,
            },
            thinking: {
                src: require("@/assets/imgs/dialog/chara/odda-thinking.png"),
                width: 213,
                height: 209,
                offsetX: 16,
            },
        },
    },
    "map.speaker.poca": {
        expressions: {
            smile: {
                src: require("@/assets/imgs/dialog/chara/poca-smile.png"),
                width: 277,
                height: 215,
                offsetX: 20,
            },
            happy: {
                src: require("@/assets/imgs/dialog/chara/poca-happy.png"),
                width: 277,
                height: 215,
                offsetX: 20,
            },
        },
    },
    "map.speaker.udon": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/udon-normal.png"),
                width: 229,
                height: 229,
            },
            unhappy: {
                src: require("@/assets/imgs/dialog/chara/udon-unhappy.png"),
                width: 229,
                height: 229,
            },
        },
    },
    "map.speaker.typhon": {
        expressions: {
            normal: {
                src: require("@/assets/imgs/dialog/chara/typhon-normal.png"),
                width: 240,
                height: 264,
                offsetX: 16,
            },
            eyeclosed: {
                src: require("@/assets/imgs/dialog/chara/typhon-eyeclosed.png"),
                width: 240,
                height: 264,
                offsetX: 16,
            },
        },
    },
    "map.speaker.w": {
        expressions: {
            evil: {
                src: require("@/assets/imgs/dialog/chara/w-evil.png"),
                width: 211,
                height: 207,
            },
            disdain: {
                src: require("@/assets/imgs/dialog/chara/w-disdain.png"),
                width: 211,
                height: 207,
            },
            frown: {
                src: require("@/assets/imgs/dialog/chara/w-frown.png"),
                width: 211,
                height: 207,
            },
        },
    },
}

export type CharaAvatar = CharaExpression | undefined

/** 对话框姓名条上方装饰文案（默认取 speaker 键末段大写，如 PASSENGER） */
export function getSpeakerDecorLabel(speaker: string): string {
    const overrides: Record<string, string> = {
        "map.speaker.w": "WIS'ADEL",
        "map.speaker.udon": "Укусик",
    }
    if (overrides[speaker]) return overrides[speaker]
    return speaker.split(".").pop()?.toUpperCase() ?? ""
}

export function getCharaAvatar(
    speaker: string,
    expression?: string,
): CharaAvatar {
    const config = charaAssetsMap[speaker]
    if (!config) return undefined
    if (expression && config.expressions[expression]) {
        return config.expressions[expression]
    }
    const keys = Object.keys(config.expressions)
    return keys.length > 0 ? config.expressions[keys[0]] : undefined
}
